import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EventBusService, EventType, ATMEventData } from '../services/eventbus.service';
import { environment } from '../../environments/environment';
import { AuthenticationService, User } from '@csx/security';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/localstorage.service';
import { PollService } from '../services/poll.service';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ProxyUser } from '../models/proxyuser';
import { MenuItem } from 'primeng/api';
import { AppConstant } from '../common/app.constant';
import { DataService } from '../services/data.service';


declare const window;

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnChanges {
  host = window.location.hostname;
  uatHostName = 'atam-qa.csx.com';
  stagingInternalHostName = 'atam-staging.go-dev.csx.com';
  stagingExternalHostName = 'atam-staging.csx.com';
  devHostName = 'atam-dev.csx.com';
  appLongName = 'Automated Track Authority and Messaging';
  appShortName = 'ATAM - ' + environment.appConfig.appVersion;
  @Input() appUser: string;
  @Input() login: boolean;
  @Input() isServiceWorkerSupported: boolean;
  showUserNotification = true;
  notificationPages = ['/welcome', '/verify', '/logout'];
  href: string;
  routeName: String;
  onlineStatus = 'app-online';
  showLogoutWarning: Boolean = false;
  showProxy: Boolean = false;
  showOutageScreen = false;
  showNotificationScreen = false;
  userId: string;
  outageComment: string;
  proxyErrorMessage: string;
  outageErrorMessage: string;
  proxiedUser: string;
  authorityMenu: MenuItem[] = AppConstant.ELIPSIS_MENU_ADMIN;
  isRegularMaintenance = false;



  constructor(private eventBusService: EventBusService, private authService: AuthenticationService, private router: Router,
    private localStorage: LocalStorageService, private user: User, private pollService: PollService,
    private _location: Location, private httpClient: HttpClient, private proxy: ProxyUser,
    private eventBus: EventBusService, private dataService: DataService

  ) {
    this.proxiedUser = this.proxy.racf === undefined ? 'None' : this.proxy.racf;
    this.appUser = this.user.lastName + ' ' + this.user.firstName + '(' + this.user.racf + ')';
    this.eventBusService.getEventBus(EventType.ONLINE_EVENT)
      .subscribe(response => this.onlineStatus = 'app-online');
    this.eventBusService.getEventBus(EventType.OFFLINE_EVENT)
      .subscribe(response => this.onlineStatus = 'app-offline');
    this.eventBusService.getEventBus(EventType.REGULARMAINTENANCE)
      .subscribe((eventData: ATMEventData) => this.isRegularMaintenance = true);
    this.eventBusService.getEventBus(EventType.REGULARMAINTENANCE_CLEARED)
      .subscribe((eventData: ATMEventData) => this.isRegularMaintenance = false);

    this.router.events.subscribe(value => {
      this.href = router.url.toString();
      let route = this.href.split('/')
      if (route.indexOf('history') > 0) {
        this.routeName = 'History';
      } else if (route.indexOf('authorities') > 0 ||
        route.indexOf('authorities?status=open') > 0 || route.indexOf('authorities?status=released') > 0
        || route.indexOf('authorities?status=cancelled') > 0 || route.indexOf('authorities?status=rejected')
      ) {
        this.routeName = 'Authorities';
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.host = window.location.hostname;
    if (this.host === this.uatHostName) {
      this.appLongName = 'This is a UAT version meant only for testing and training.';
      this.appShortName = 'UAT - ATAM - ' + environment.appConfig.appVersion;
    }
    if ((this.host === this.stagingInternalHostName) || (this.host === this.stagingExternalHostName)) {
      this.appLongName = 'This is a STAGING version meant only for testing and training.';
      this.appShortName = 'STAGING - ATAM - ' + environment.appConfig.appVersion;
    }
    if (this.host === this.devHostName) {
      this.appLongName = 'This is a DEV version meant only for development and testing.';
      this.appShortName = 'DEV - ATAM - ' + environment.appConfig.appVersion;
    }
    this.hideActions();
  }

  hideActions() {
    this.authorityMenu[0].visible = this.authService.isRoleAuthorized(['client.atam.admin', 'client.atam.developer']);
    this.authorityMenu[1].visible = this.authService.isRoleAuthorized(['client.atam.admin.appmaintainer']);
  }

  onLogout() {
    this.appUser = '';
    this.pollService.stopPoll();
    this.localStorage.removeUserDetail(this.authService.user).catch(exception => {
      console.warn(exception);
    });
    this.authService.logout();
    this.deleteSession();
    localStorage.clear();
    this.router.navigate(['/logout']);
  }

  initiateLogoutProcess(): void {
    if (!window.navigator.onLine) {
      this.showLogoutWarning = true;
      return;
    } else {
      this.onLogout();
    }
  }


  allowLogout(isAllowed: boolean): void {
    this.showLogoutWarning = false;
    if (isAllowed) {
      this.onLogout();
    }
  }
  isNonProduction(): boolean {
    return [this.stagingInternalHostName,
    this.stagingExternalHostName,
    this.devHostName,
    this.uatHostName].indexOf(
      this.host) >= 0;
  }


  backClicked() {
    this._location.back();
  }

  public deleteSession(): void {
    let request = this.httpClient.delete(environment.appConfig.api.logoutUrl, {
      withCredentials: true
    });

    request.subscribe(response => console.info('RESPONSE', response));
  }

  isProxyNotAllowed(): boolean {
    return !this.authService.isRoleAuthorized(['client.atam.admin', 'client.atam.developer']);
  }

  proxyClicked(): void {
    this.userId = undefined;
    this.proxyErrorMessage = undefined;
    this.showProxy = true;
  }

  ouatageScreenClicked(): void {
    this.outageComment = undefined;
    this.outageErrorMessage = undefined;
    this.showOutageScreen = true;
  }

  closeProxy(): void {
    this.showProxy = false;
  }
  closeOuatgeScreen(): void {
    this.showOutageScreen = false;
  }
  proxyUser(): void {
    if (this.user.racf === this.userId) {
      this.proxyErrorMessage = 'Cannot Proxy with same Racf';
      return;
    } if (this.userId !== undefined && this.userId.length === 5 && this.validateRacf()) {
      this.proxy.setProxyUser(this.userId);
      this.proxiedUser = this.proxy.racf === undefined ? 'None' : this.proxy.racf;

      this.showProxy = false;
      this.eventBus.fireEvent(
        EventType.RESET_POLL_EVENT,
        new ATMEventData(null, () => '')
      );
      this.eventBus.fireEvent(
        EventType.NOTIFY_SUCCESS_EVENT,
        new ATMEventData(
          null,
          () =>
            'Proxy Successfully Applied'
        )
      );
    } else {
      this.proxyErrorMessage = 'Enter Valid Proxy';
      return;
    }

  }

  validateRacf(): boolean {
    const regex = RegExp('^[A-Z][0-9]{4}$');
    return regex.test(this.userId);
  }

  onClickAuthorityMenu(event) {
    if (event.target.innerText === 'Proxy User') {
      this.proxyClicked();
    } else if (event.target.innerText === 'Manage Outage') {
      this.ouatageScreenClicked();
    }
  }

  showOuatageAndProxy(): boolean {
    return this.authService.isRoleAuthorized(['client.atam.admin', 'client.atam.developer', 'client.atam.admin.appmaintainer']);
  }
  raiseOutage() {
    if (this.outageComment === undefined || this.outageComment.trim().length === 0) {
      this.outageErrorMessage = 'Reason for Creating Outage is Required';
      return;
    } else {
      this.outageErrorMessage = undefined;
    }
    this.dataService.raiseOutage(this.outageComment).then(() => {
      this.eventBus.fireEvent(
        EventType.RESET_POLL_EVENT,
        new ATMEventData(null, () => '')
      );
      this.eventBus.fireEvent(
        EventType.NOTIFY_SUCCESS_EVENT,
        new ATMEventData(
          null,
          () =>
            'Outage is Raised'
        )
      );
    });
    this.closeOuatgeScreen();
  }

  clearOutage() {
    this.dataService.raiseOutage().then(() => {
      this.eventBus.fireEvent(
        EventType.RESET_POLL_EVENT,
        new ATMEventData(null, () => '')
      );
      this.eventBus.fireEvent(
        EventType.NOTIFY_SUCCESS_EVENT,
        new ATMEventData(
          null,
          () =>
            'Outage is Cleared'
        )
      );

    });
    this.closeOuatgeScreen();
  }
}
